<template>
    <div class="row">
        <div class="col-12 mb-5">
            <div class="alert alert-info">
                <small>{{ $trans.get('__JSON__.Only for this contract the number of hours worked is limited, based on the settings below.') }}</small>
            </div>
        </div>

        <div class="col-12 mb-5">
            <label class="form-label" for="type">
                {{ $trans.get('__JSON__.Type') }}
            </label>
            <v-select v-model="formData.type" :options="types" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('type') }" />
            <span class="invalid-feedback" role="alert" v-if="this.hasError('type')">
                <strong>{{ this.getError('type') }}</strong>
            </span>
        </div>

        <div class="col-12">
            <label class="form-label" for="amount">
                {{ $trans.get('__JSON__.Amount of hours') }}
            </label>
            <input type="number" min="0" name="amount" class="form-control" :class="{ 'is-invalid': this.hasError('amount') }" id="amount" v-model="formData.amount">
            <p class="text-sm text-muted">
                {{ $trans.get('__JSON__.To remove any restriction, just remove the amount and submit') }}
            </p>
            <span class="invalid-feedback" role="alert" v-if="this.hasError('amount')">
                <strong>{{ this.getError('amount') }}</strong>
            </span>
        </div>
    </div>
</template>

<script>
import RequestHandler from "../../mixins/RequestHandler";
import vSelect from "vue-select";
import ContractInfo from "../ContractInfo.vue";

export default {
    name: 'WorkingHoursForm',
    mixins: [RequestHandler],
    components: {vSelect, ContractInfo},
    data() {
        return {
            contractId: this.$parent.$data.contractId,
            loading: false,
            formData: {
                type: null,
                amount: null,
            },
            types: this.$parent.$data.data.types,
            current: this.$parent.$data.data.current,
        }
    },
    mounted() {
        this.formData.type = this.current.type || 'weekly'
        this.formData.amount = this.current.amount
    },
}
</script>
